export const DATE_RANGE_STORAGE_KEY = "gantt-date-range";
export const NULL_RANGE_LABEL = "--";
const DATE_RANGE_I18N_PREFIX = "views.company.workforce_planning.gantt.date_range";
/**
 * Date range options using pluralized keys with `%{count}` interpolation
 * (e.g. `date_range.week` with `{ count: 2 }` → "2 Weeks").
 */
export const DATE_RANGE_OPTIONS = [
   { translationKey: null, count: 0, days: null },
   { translationKey: `${DATE_RANGE_I18N_PREFIX}.week`, count: 1, days: 7 },
   { translationKey: `${DATE_RANGE_I18N_PREFIX}.week`, count: 2, days: 14 },
   { translationKey: `${DATE_RANGE_I18N_PREFIX}.week`, count: 4, days: 28 },
   { translationKey: `${DATE_RANGE_I18N_PREFIX}.week`, count: 8, days: 56 },
   { translationKey: `${DATE_RANGE_I18N_PREFIX}.week`, count: 13, days: 91 },
   { translationKey: `${DATE_RANGE_I18N_PREFIX}.month`, count: 6, days: 182 },
   { translationKey: `${DATE_RANGE_I18N_PREFIX}.year`, count: 1, days: 364 },
   { translationKey: `${DATE_RANGE_I18N_PREFIX}.year`, count: 2, days: 730 },
   { translationKey: `${DATE_RANGE_I18N_PREFIX}.year`, count: 3, days: 1095 },
   { translationKey: `${DATE_RANGE_I18N_PREFIX}.year`, count: 5, days: 1825 },
] as const;
export const defaultPreset = {
   id: "my_weekAndDay-54by80",
   base: "weekAndDay-54by80",
   mainUnit: "week",
   defaultSpan: 1,
   tickWidth: 74,
   timeResolution: {
      unit: "day",
      increment: 1,
   },
} as const;
export type DateRangeDays = (typeof DATE_RANGE_OPTIONS)[number]["days"];
export type GanttDateRangeSelectorProps = {
   selectedRange: DateRangeDays;
   onRangeChange: (days: DateRangeDays) => void;
};
